import { create } from 'zustand';
import type { BulkSection } from './bulkStore';
import type { EscalarItem } from '../components/modals/EscalarModal';

export type ItemsResolver = (ids: string[]) => EscalarItem[];
export type TaskResolver = (ids: string[]) => string[];

interface SelectedIdState {
  pending: Partial<Record<BulkSection, string>>;
  resolvers: Partial<Record<BulkSection, ItemsResolver>>;
  taskResolvers: Partial<Record<BulkSection, TaskResolver>>;
  setPending: (section: BulkSection, id: string) => void;
  consume: (section: BulkSection) => string | null;
  setResolver: (section: BulkSection, resolver: ItemsResolver | null) => void;
  setTaskResolver: (
    section: BulkSection,
    resolver: TaskResolver | null
  ) => void;
}

export const useSelectedIdStore = create<SelectedIdState>((set, get) => ({
  pending: {},
  resolvers: {},
  taskResolvers: {},
  setPending: (section, id) =>
    set(state => ({ pending: { ...state.pending, [section]: id } })),
  consume: section => {
    const current = get().pending[section];
    if (!current) return null;
    set(state => {
      const next = { ...state.pending };
      delete next[section];
      return { pending: next };
    });
    return current;
  },
  setResolver: (section, resolver) =>
    set(state => {
      const next = { ...state.resolvers };
      if (resolver) next[section] = resolver;
      else delete next[section];
      return { resolvers: next };
    }),
  setTaskResolver: (section, resolver) =>
    set(state => {
      const next = { ...state.taskResolvers };
      if (resolver) next[section] = resolver;
      else delete next[section];
      return { taskResolvers: next };
    }),
}));

export const selectedIdStore = useSelectedIdStore;
